import { getIn } from "formik";
import { IEsvcsEnrollment } from "csd.phoenix.models/EsvcsEnrollment";
import { IFormContext } from "../../../shared/form/FormContext";
import { DpmsTypes } from 'csd.phoenix.models/DpmsTypes';
import { getDpmsList } from "../../../shared/ListData";
import { EsvcsProductOfferings } from "csd.phoenix.models/EsvcsProductOfferings";
import { isLocaleUS } from "../../../../i18n";

export function handleFieldChanged(
  fieldName: string,
  value: unknown,
  oldValue: unknown,
  values: IEsvcsEnrollment,
  setFieldValue: (field: string, value: any) => void,
  context: IFormContext
) {
  if (fieldName === "ProductOffering") {
    setFieldValue("PartnerId", undefined);
    // Is the current DPMS type value valid for this product type?
    var dpmsType = getIn(values, "DpmsType");
    var isValidDpmsType = !!getDpmsList(value as EsvcsProductOfferings).find(dpms => dpms.value === dpmsType);
    if (!isValidDpmsType)
      setFieldValue("DpmsType", undefined);
    context.setFieldPropOverrides("PartnerId", { disabled: true });
  }
  else if (fieldName === "DpmsType") {
    const dpmsType = getIn(values, "DpmsType");
    // if the DPMS type has changed remove the value of the DPMS version and
    // clear out the timezone so that the user needs to set it.
    setFieldValue("DpmsVersion", undefined);
    setFieldValue("TimeZone", undefined);
    if (!isLocaleUS()) {
      setFieldValue("LocaleId", undefined);
    }
    context.setFieldPropOverrides("DpmsVersion", {});
    context.setFieldPropOverrides("TimeZone", {});
    context.setFieldPropOverrides("LocaleId", {});

    // Disable the DMPSVersion and timezone fields if the DMPS is Sensei Cloud
    const disableAdditionalControls = dpmsType === DpmsTypes.CMP;
    context.setFieldPropOverrides("DpmsVersion", { disabled: disableAdditionalControls });
    context.setFieldPropOverrides("TimeZone", { disabled: disableAdditionalControls });
    context.setFieldPropOverrides("LocaleId", { disabled: disableAdditionalControls });
  }

}

export function handleFormLoaded(values: IEsvcsEnrollment, context: IFormContext) {
  const dpmsType = getIn(values, "DpmsType");

  // if (!isAPartnerApi) {
  //   context.setFieldPropOverrides("PartnerId", { disabled: true });
  // }
  if (!dpmsType) {
    context.setFieldPropOverrides("DpmsVersion", { disabled: true });
    context.setFieldPropOverrides("TimeZone", { disabled: true });
    context.setFieldPropOverrides("LocaleId", { disabled: true });
  }
}

// const ChangeHandler = () => {
//   useFieldChangeTracker(handleFieldChanged, handleFormLoaded);
//   return null;
// }
// export default ChangeHandler;



